import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8337cb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tool_tip_nav"
}
const _hoisted_2 = { key: 1 }

import Icon from '@/components/atoms/Icon'
import RadioButtonToolTip from '@/components/molecules/RadioButtonToolTip'
import APP from '@/js/const/app'
import HoverToolTip from '@/components/molecules/HoverToolTip'
import i18n from '@/plugins/i18n'
import { computed, ref, withDefaults } from 'vue'
import { UserPermissions } from '@/@types/typescript-axios'

type PropsType = {
  //   マルチではない場合undefinedになる
  division?: number | undefined
  useController?: boolean
  isMultiVideo?: boolean
  useArchiveDownloadNav?: boolean
  useEnterAlertCsvDownloadNav?: boolean
  useLightingController?: boolean
  liveState?: boolean
  permissions: UserPermissions
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerToolTip',
  props: {
    division: null,
    useController: { type: Boolean, default: false },
    isMultiVideo: { type: Boolean, default: false },
    useArchiveDownloadNav: { type: Boolean, default: false },
    useEnterAlertCsvDownloadNav: { type: Boolean, default: false },
    useLightingController: { type: Boolean, default: false },
    liveState: { type: Boolean, default: false },
    permissions: null
  },
  emits: ["click", "mouseleave", "showEnterAlertCsvDownloadDialog", "changeDivision", "change", "showDirectionController", "showLightingController", "showArchiveDownloadDialog"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void
  (e: 'mouseleave'): void
  (e: 'showEnterAlertCsvDownloadDialog'): void
  (e: 'changeDivision', value: number): void
  (e: 'change', value: number | undefined): void
  (e: 'showDirectionController'): void
  (e: 'showLightingController'): void
  (e: 'showArchiveDownloadDialog'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { division?: number | undefined, useController: boolean, isMultiVideo: boolean, useArchiveDownloadNav: boolean, useEnterAlertCsvDownloadNav: boolean, useLightingController: boolean, liveState: boolean, permissions: UserPermissions };

const divisionOptions = ref<{ [key: string]: string | number }[]>(APP.MULTI_VIDEO_DIVISION_OPTIONS)

const isShowNav = ref(true)
const isShowDivisionNav = ref(false)





const selectedDivision = computed({
  get: () => props.division,
  set: (newVal) => {
    if (props.division !== newVal) {
      emit('change', newVal)
    }
  },
})

const disableHoverText = computed<(noPermission: boolean) => string>(() => {
  return (noPermission) => {
    let text = ''
    if (noPermission) {
      text = i18n.global.t('player_tool_tip.no_permission')
    } else if (!props.liveState) {
      text = i18n.global.t('player_tool_tip.valid_for_live')
    }
    return text
  }
})

const disablePermissionHoverText = computed<(noPermission: boolean) => string>(() => {
  return (noPermission) => {
    let text = ''
    if (noPermission) {
      text = i18n.global.t('player_tool_tip.no_permission')
    }
    return text
  }
})

const disableLightingController = computed<boolean>(
  () => !props.liveState || !props.permissions.lighting
)
const disableDirectionController = computed<boolean>(
  () => !props.liveState || !props.permissions.ptz
)
const disableArchiveDownload = computed<boolean>(
  () => !props.permissions.archive || !props.permissions.batchDownload
)

const showDivisionNav = () => {
  isShowNav.value = false
  isShowDivisionNav.value = true
}

const showDirectionController = () => {
  if (disableDirectionController.value) {
    return
  }
  isShowNav.value = false
  emit('showDirectionController')
}

const showLightingController = () => {
  if (disableLightingController.value) {
    return
  }
  isShowNav.value = false
  emit('showLightingController')
}

const showArchiveDownloadDialog = () => {
  if (disableArchiveDownload.value) {
    return
  }
  isShowNav.value = false
  emit('showArchiveDownloadDialog')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "player_tool_tip",
    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('mouseleave'))),
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [
    (isShowNav.value)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
          _createElementVNode("ul", null, [
            (__props.useLightingController)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass({ disable_li: _unref(disableLightingController) }),
                  onClick: showLightingController
                }, [
                  _createVNode(_unref(HoverToolTip), {
                    "tool-tip-text": _unref(disableHoverText)(!__props.permissions.lighting),
                    width: 200
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass({ disable_menu: _unref(disableLightingController) })
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('player_tool_tip.lighting')), 1),
                        _createVNode(_unref(Icon), {
                          type: "keyboard_arrow_right",
                          color: "color-white"
                        })
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["tool-tip-text"])
                ], 2))
              : _createCommentVNode("", true),
            (__props.useController)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 1,
                  class: _normalizeClass({ disable_li: _unref(disableDirectionController) }),
                  onClick: showDirectionController,
                  "data-test": "player-tooltip-ptz-btn"
                }, [
                  _createVNode(_unref(HoverToolTip), {
                    "tool-tip-text": _unref(disableHoverText)(!__props.permissions.ptz),
                    width: 200
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass({ disable_menu: _unref(disableDirectionController) })
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('player_tool_tip.ptz_control')), 1),
                        _createVNode(_unref(Icon), {
                          type: "keyboard_arrow_right",
                          color: "color-white"
                        })
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["tool-tip-text"])
                ], 2))
              : _createCommentVNode("", true),
            (__props.isMultiVideo)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 2,
                  onClick: showDivisionNav
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('player_tool_tip.number_of_divisions')), 1),
                  _createVNode(_unref(Icon), {
                    type: "keyboard_arrow_right",
                    color: "color-white"
                  })
                ]))
              : _createCommentVNode("", true),
            (__props.useArchiveDownloadNav)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 3,
                  class: _normalizeClass({ disable_li: _unref(disableArchiveDownload) }),
                  onClick: showArchiveDownloadDialog
                }, [
                  _createVNode(_unref(HoverToolTip), {
                    "tool-tip-text": _unref(disablePermissionHoverText)(_unref(disableArchiveDownload)),
                    width: 200
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass({ disable_menu: _unref(disableArchiveDownload) })
                      }, _toDisplayString(_ctx.$t('player_tool_tip.download_past_video')), 3)
                    ]),
                    _: 1
                  }, 8, ["tool-tip-text"])
                ], 2))
              : _createCommentVNode("", true),
            (__props.useEnterAlertCsvDownloadNav)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 4,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showEnterAlertCsvDownloadDialog')))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('player_tool_tip.download_enter_alert_csv')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (isShowDivisionNav.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(RadioButtonToolTip), {
            modelValue: _unref(selectedDivision),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedDivision) ? (selectedDivision).value = $event : null)),
            title: _ctx.$t('player_tool_tip.number_of_divisions'),
            options: divisionOptions.value,
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('changeDivision', $event)))
          }, null, 8, ["modelValue", "title", "options"])
        ]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})